module["exports"] = [
  "s Väg",
  "s Gata"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/address/common_street_suffix.js
// module id = 1977
// module chunks = 0